import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'IconBadge',
  props: {
    value: { default: 0 },
    iconDescription: { default: '' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})